<template>
    <div class="homeinterativa">
        <PageTitle icon="fas fa-hand-holding-usd iconInterativoTitulo" main="Gestão Financeira"
            sub="Acompanhe suas aquisições, seus pedidos e gerencie as finanças de sua operação" />
        <div class="stats">
            <Stat title="Aquisições" :value="stat.maquinas"
                icon="fas fa-shopping-cart" color="#2e2d2c" />
            <Stat title="Diagnóstico da Operação" :value="stat.baterias"
                icon="fas fa-chart-pie" color="#ffd618" />
            <Stat title="Pedidos" :value="stat.usuarios"
                icon="fas fa-money-check-alt" color="#008fac" />
        </div>
    </div>
</template>

<script>
import PageTitle from '../PageTitle'
import Stat from './Stat'
import axios from 'axios'
import { baseApiUrl } from '@/global'

export default {
    name: 'FinancaInterativa',
    components: { PageTitle, Stat },
    data: function() {
        return {
            stat: {}
        }
    },
    methods: {
        getStats() {
            axios.get(`${baseApiUrl}/stats`).then(res => this.stat = res.data)
        }
    },
    mounted() {
        this.getStats()
    }
}
</script>

<style>
    .stats {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 20px;
    }
    .homeinterativa{
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>